"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _ramda = require("ramda");

var _useConvertMultiCurrency = _interopRequireDefault(require("../hooks/useConvertMultiCurrency"));

var _ConversionResultMulti = _interopRequireDefault(require("./ConversionResultMulti"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    root: {
      padding: spacing(1.5, 2, 1, 1.5),
      border: "1px solid ".concat(palette.dividerLight),
      borderRadius: 3
    }
  };
});

var MultiCurrencyConverter = function MultiCurrencyConverter(_ref2) {
  var priceMin = _ref2.priceMin,
      priceMax = _ref2.priceMax,
      fromCurrencyId = _ref2.fromCurrencyId,
      toCurrencyIds = _ref2.toCurrencyIds,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? 'Gift card' : _ref2$title;
  var classes = useStyles();
  var shouldConvertMin = Boolean(priceMin > 0 && priceMin <= 5000 && fromCurrencyId && toCurrencyIds.length > 0);
  var shouldConvertMax = Boolean(priceMax > 0 && priceMax <= 5000 && fromCurrencyId && toCurrencyIds.length > 0);
  var shouldConvert = shouldConvertMin && shouldConvertMax;
  var uniqCurrencyIds = (0, _react.useMemo)(function () {
    return (0, _ramda.uniq)(toCurrencyIds);
  }, [toCurrencyIds]);

  var _useConvertMultiCurre = (0, _useConvertMultiCurrency.default)({
    fromCurrencyId,
    toCurrencyIds: uniqCurrencyIds,
    priceMax,
    priceMin,
    shouldConvert
  }),
      conversions = _useConvertMultiCurre.conversions,
      isLoading = _useConvertMultiCurre.isLoading;

  var pairedConversions = (0, _react.useMemo)(function () {
    var result = {};
    conversions.forEach(function (conversion) {
      if (result[conversion.toCurrencyId]) {
        result[conversion.toCurrencyId].push(conversion);
      } else {
        result[conversion.toCurrencyId] = [conversion];
      }
    });
    return result;
  }, [conversions]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Regular-Left-Static-Bold"
  }, "Currency converter"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    my: 1
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Subcopy-Static-Alt"
  }, title, " amount will be rounded"), /*#__PURE__*/_react.default.createElement(_ui.Tooltip, {
    title: "The exact converted cost will be calculated once your recipient has accepted the gift.",
    placement: "top-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    "data-testid": "CurrencyConverter.ApproximateCharge.Hint",
    color: "grey.main",
    icon: "info-circle",
    fontSize: 1
  })))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    whiteSpace: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    flex: "1 1 65%"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Recipient receives"))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    style: {
      maxHeight: 200,
      overflow: 'scroll',
      flexDirection: 'column'
    }
  }, !isLoading && shouldConvert && Object.keys(pairedConversions).map(function (key) {
    var values = pairedConversions[key];
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      pt: 1,
      pb: 1,
      whiteSpace: "nowrap",
      key: key
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      flex: "1 1 65%",
      "data-testid": "CurrencyConverter.ConversionResult"
    }, /*#__PURE__*/_react.default.createElement(_ConversionResultMulti.default, {
      fromCurrencyId: values[0].fromCurrencyId,
      toCurrencyId: values[0].toCurrencyId,
      prices: values,
      exchangeRate: values[0].exchangeRate
    })));
  })), isLoading && uniqCurrencyIds.map(function (id) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      display: "flex",
      pt: 1.5,
      pb: 1.5,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
      width: "65%",
      height: 40
    }), /*#__PURE__*/_react.default.createElement(_ui.LoadingLabel, {
      width: "35%",
      height: 40,
      ml: 2
    }));
  }), !isLoading && !shouldConvert && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2.5,
    mb: 2.5,
    "data-testid": "CurrencyConverter.NoData"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, null, "Not calculated")));
};

var _default = /*#__PURE__*/(0, _react.memo)(MultiCurrencyConverter);

exports.default = _default;